// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_l0-0";
export var discountCodeInput = "_l0-1";